/** What a log write route answers: the writes it dropped, by id, which never reach the log. */
export type OptimisticBatchResult = { dropped: readonly { id: string }[] };

/** One batch of writes the store already shows, and how to send it and take it back. */
export type OptimisticBatch = {
  /** Every write in the batch, by id: what a failed request takes back. */
  ids: readonly string[];
  send: () => Promise<OptimisticBatchResult>;
  /** Removes writes from the store, by id. */
  takeBack: (ids: readonly string[]) => void;
  /** Reports a request that failed outright, before its batch is taken back. */
  onFailure: (error: unknown) => void;
};

/**
 * Sends one batch of writes the store already shows, and takes back what the server does not keep.
 *
 * A write the server drops leaves the store; a request that fails outright is reported and takes the whole batch
 * back, so the page never shows a row the log does not hold.
 */
export function sendOptimisticBatch(batch: OptimisticBatch): void {
  batch
    .send()
    .then((result) => batch.takeBack(result.dropped.map((dropped) => dropped.id)))
    .catch((error: unknown) => {
      batch.onFailure(error);
      batch.takeBack(batch.ids);
    });
}
